import React, { useMemo } from 'react'

import { useNavigation } from 'redux/hooks/NavigationMenuStore'
import { useNavigationActions } from 'redux/actions/NavigationMenu'
import { useAllowAccessAnalyses } from 'redux/hooks/Permissions'
import { useTranslation } from 'language/translator'

import NavigationMenu from 'components_new/molecules/NavigationMenu'
import { TNavigationItem } from 'components_new/molecules/NavigationItem'

import { RESULTS_NAV_MENU_ID } from 'components_new/organisms/Navbar/lib'

const ResultsNavigation = () => {
  const { open, expandedItems } = useNavigation()
  const { toggleNavigationItem } = useNavigationActions()

  const allowAnalyses = useAllowAccessAnalyses()

  const { t } = useTranslation()

  const items: TNavigationItem[] = useMemo(() => {
    return [
      {
        activePattern: '/results*',
        icon: { name: 'Grid' } as const,
        href: '/results',
        title: t('global', 'overview')
      },
      {
        activePattern: '/tasks*',
        icon: { name: 'Tasks' } as const,
        href: '/tasks',
        title: t('tasks', 'tasks')
      },
      {
        activePattern: '/analyses*',
        icon: { name: 'Analyses' } as const,
        href: '/analyses',
        title: t('analyses', 'analyses')
      }
    ]
  }, [])

  if (!allowAnalyses) {
    return null
  }

  return (
    <NavigationMenu
      collapsed={{
        activePattern: '/results*',
        href: '/results',
        iconName: 'Results',
        value: !open
      }}
      expandedItems={expandedItems}
      id={RESULTS_NAV_MENU_ID}
      items={items}
      title={t('global', 'results')}
      toggleNavigationItem={(id) => {
        toggleNavigationItem(id)
      }}
    />
  )
}

export default ResultsNavigation
